import type { ComponentType } from 'react';

import classNames from 'classnames';

export enum ChipVariant {
  DEFAULT = '',
  PINK = 'pink',
  PURPLE = 'purple',
  BLUE = 'blue',
  GREEN = 'green',
  RED = 'red',
  ORANGE = 'orange',
  WHITE = 'white',
}

export enum ChipSubVariant {
  BORDERED = 'bordered',
}

export enum ChipSize {
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
  XLARGE = 'xl',
}

type Props = {
  size?: ChipSize;
  icon?: ComponentType<{ className?: string }> | null;
  text?: string | number;
  isReversed?: boolean;
  variant?: ChipVariant;
  subVariant?: ChipSubVariant;
  className?: string;
  customIconColorClassName?: string;
};

export const Chip = ({
  size = ChipSize.SMALL,
  icon,
  text = '',
  variant = ChipVariant.DEFAULT,
  subVariant,
  isReversed = false,
  className = '',
  customIconColorClassName = '',
}: Props) => {
  const Icon = icon;

  return (
    <span
      className={classNames(
        `chip chip-${size}`,
        variant === ChipVariant.DEFAULT ? '' : `chip-${variant}${isReversed ? '-reverse' : ''}`,
        subVariant === ChipSubVariant.BORDERED ? 'border border-base-border-dark' : '',
        className,
      )}
    >
      {Icon && <Icon className={classNames('chip-icon', customIconColorClassName)} />}
      {text}
    </span>
  );
};
